import { render, staticRenderFns } from "./ProductPrice.vue?vue&type=template&id=0e0d0d50&functional=true"
import script from "./ProductPrice.vue?vue&type=script&lang=js"
export * from "./ProductPrice.vue?vue&type=script&lang=js"
import style0 from "./ProductPrice.vue?vue&type=style&index=0&id=0e0d0d50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports